export default __webpack_public_path__ + "static/media/DeclineIcon.5211fef0.svg";